
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

interface HistoryTextProps {
  isShow: boolean;
}

function HistoryText ({isShow}: HistoryTextProps) {
  const { t } = useTranslation();
  return isShow ? (
    <div className="text-cool-gray-600">
      <span>
        {t("historyText.part1")}
        <br /> {t("historyText.part2")}{" "}
      </span>
      <Link className="text-primary" to="/app/history">
        {t("historyText.link")}
      </Link>
    </div>
  ) : null;
};

export default HistoryText;